export const COMPANY_START = 'company/company-start';
export const COMPANY_SUCCESS = 'company/company-success';
export const COMPANY_ERROR = 'company/company-error';
export const COMPANY_START_DELETE = 'company/company-start-delete';
export const COMPANY_SUCCESS_DELETE = 'company/company-success-delete';
export const COMPANY_ERROR_DELETE = 'company/company-error-delete';
export const COMPANY_UPDATE_RESULTS = 'company/company-update-results';
